import { Component, ReactNode } from 'react';
import { Field, FieldInputProps, FieldProps } from 'formik';

import t from 'utils/i18n';
import { FieldStatus } from '../../BraxUncontrolledForm';
import BraxFormContext from '../context';

type RenderProps = FieldInputProps<any> & {
    formik: FieldProps,
    status: FieldStatus,
    hint?: ReactNode,
    disabled?: boolean,
    readOnly?: boolean,
    required: boolean
};

export type BraxFieldProps = Pick<RenderProps, 'name' | 'hint'> & {
    disabled: boolean,
    readOnly: boolean,
    children: (props: RenderProps) => ReactNode
};

export class BraxField extends Component<BraxFieldProps> {

    static defaultProps = {
        disabled: false,
        readOnly: false
    };

    render() {
        return (
            <BraxFormContext.Consumer>
                { context => (
                    <Field name={this.props.name}>
                        { (formik: FieldProps) => {
                            let status: FieldStatus = null;

                            let hint = this.props.hint;

                            const disabled = context.disabled || this.props.disabled;

                            const readOnly = context.readOnly || this.props.readOnly;

                            let required = false;

                            try {
                                const clone = <T extends Object>(value: T) => {
                                    value = { ...value };

                                    for (const key in value)
                                        value[key as any] = value[key] && typeof value[key] === 'object' ? clone(value[key as any]) : value[key];

                                    return value;
                                };

                                const testValue = clone(formik.form.values);

                                this.props.name.split('.').reduce((ref, path, index, paths) => {
                                    if (paths.length - 1 === index)
                                        ref[path] = undefined;
                                    else
                                        return ref[path];
                                }, testValue);

                                context.schema.validateSyncAt(this.props.name, testValue);
                            } catch (error) {
                                if (error && error.name === 'ValidationError' && error.type === 'required')
                                    required = true;
                            }

                            if (disabled) {
                                status = 'disabled';
                            } else if (readOnly) {
                                status = 'read-only';
                            } else if (formik.meta.touched && formik.meta.error !== undefined) {
                                status = 'error';

                                hint = t(formik.meta.error);
                            } else if (formik.field.value) {
                                status = 'success';
                            }

                            return this.props.children({
                                ...formik.field,
                                formik,
                                status,
                                hint,
                                disabled,
                                readOnly,
                                required
                            });
                        } }
                    </Field>
                ) }
            </BraxFormContext.Consumer>
        );
    }

}
